import { render, staticRenderFns } from "./Message.html?vue&type=template&id=5ed8ab8c&scoped=true&"
import script from "./Message.js?vue&type=script&lang=js&"
export * from "./Message.js?vue&type=script&lang=js&"
import style0 from "./Message.scss?vue&type=style&index=0&id=5ed8ab8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed8ab8c",
  null
  
)

export default component.exports